<dl class="cl-dl">
  <dt>
    <div class="form-check cl-spacing-none">
      <input
        [id]="checkboxId"
        [disabled]="disabled"
        [ngModel]="checked"
        [class.invalid]="invalid"
        (ngModelChange)="onCheckedChange($event)"
        class="form-check-input"
        type="checkbox"
      >
      <label class="form-check-label" [class.invalid]="invalid" [for]="checkboxId">
        {{ label }} 
        @if (required) {
          <span class="required">*</span>
        }
      </label>
    </div>
  </dt>
  <dd>
    <p>{{ description }}</p>
    <ng-content></ng-content>
  </dd>
</dl>
